import PlanoService from '../services/plano.service';

export const plan = {
  namespaced: true,
  state: { planList: [] },
  actions: {
    async createNewPlan({ dispatch }, plano) {
      const resp = await PlanoService.createNewPlan(plano);
      if (resp.status === 200) dispatch('getPlanList');
      return resp.status;
    },

    async changePlanData(_, planData) {
      const resp = await PlanoService.putPlanData(planData);
      return resp.status;
    },
    async getPlanList({ commit }) {
      const resp = await PlanoService.getPlanList();
      commit('SET_PLAN_LIST', resp.data);
      return resp.status;
    },
    async getPlanListPublic({ commit }, residencia) {
      const resp = await PlanoService.getPlanListPublic(residencia);
      commit('SET_PLAN_LIST', resp.data);
      return resp.status;
    },
    async deletePlan(_, idPlan) {
      const resp = await PlanoService.deletePlan(idPlan);
      return resp.status;
    },
  },
  mutations: {
    SET_PLAN_LIST(state, planList) {
      state.planList = planList;
    },
  },
};
